import { RequestContext } from "./RequestContext";

/**
 * Request kontext bez transakčního kontextu. Určeno pro požadavky, které pracují s rolemi, ale transakční kontext nepodporují.
 * @includeToDoc
 */
export type RequestContextWithoutTransactionContextId = Omit<RequestContext, "transationContextId">;
